import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Typography } from '@mui/material'

import { useGetLatestCompletedAnalysisQuery } from '../../../../api/analysis'
import { useGetInternalGameDocumentQuery } from '../../../../api/games'
import { Benchmark } from '../../types/InternalAnalysis'
import { AnalysisGameBlock } from '../AnalysisGameBlock/AnalysisGameBlock'

type BenchmarkGameBlockProps = {
  benchmark: Benchmark
  index: number
  max: number
  onRemove: () => void
}

export const BenchmarkGameBlock: FC<BenchmarkGameBlockProps> = ({ benchmark, index, max, onRemove }) => {
  const { t } = useTranslation()
  const gameQuery = useGetInternalGameDocumentQuery(benchmark.gameId)
  const analysisQuery = useGetLatestCompletedAnalysisQuery(benchmark)
  const hasAnswers = !!analysisQuery.data && Object.keys(analysisQuery.data.answers ?? {}).length > 0

  const renderError = () => {
    if (gameQuery.isError) return <Typography color="error.main">{t('internal-analysts:analysis_overview_benchmark_game_failed')}</Typography>
    if (analysisQuery.isError) return <Typography color="error.main">{t('internal-analysts:analysis_overview_benchmark_analysis_failed')}</Typography>
    if (analysisQuery.isSuccess && !hasAnswers)
      return <Typography color="error.main">{t('internal-analysts:analysis_overview_benchmark_no_analysis')}</Typography>
    return null
  }

  return (
    <AnalysisGameBlock
      title={t('internal-analysts:analysis_overview_benchmark_title', { index: index + 1, max })}
      game={gameQuery.data}
      marketIso={benchmark.marketIso}
      isLoading={gameQuery.isLoading || analysisQuery.isLoading}
      error={renderError()}
      removeLabel={t('internal-analysts:analysis_overview_benchmark_remove')}
      onRemove={onRemove}
    />
  )
}
